/*global $, jQuery, alert, console, SVGInjector, gdprCookieNotice*/

"use strict";

(function () {
  const currentUrl = window.location.href;
  const cleanedUrl = currentUrl.replace(/#!+/g, "");
  if (currentUrl !== cleanedUrl) {
    window.history.replaceState({}, document.title, cleanedUrl);
  }
})();

window.addEventListener("load", function () {
  const preloader = document.getElementById("pagePreloader");
  if (preloader) {
    preloader.style.opacity = "0";
    setTimeout(() => (preloader.style.display = "none"), 500);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const faqButtons = document.querySelectorAll(".s-faq__item-header");
  faqButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const currentItem = button.closest(".s-faq__item");
      const isActive = currentItem.classList.contains("active");

      if (isActive) {
        currentItem.classList.remove("active");
        button.setAttribute("aria-expanded", "false");
      } else {
        currentItem.classList.add("active");
        button.setAttribute("aria-expanded", "true");
      }
    });
  });
});

$(document).ready(function () {
  controlTopMenu();

  const $sidenav = $(".sidenav");

  $sidenav.sidenav({
    edge: "right",
    onOpenStart: function () {
      $sidenav.removeClass("closing");
      $sidenav.addClass("open");
    },
    onOpenEnd: function () {
      $sidenav.addClass("open");
    },
    onCloseStart: function () {
      $sidenav.addClass("closing");
      setTimeout(() => {
        $sidenav.removeClass("open");
      }, 300);
    },
    onCloseEnd: function () {
      $sidenav.removeClass("closing");
    },
  });

  $(".modal").modal();
  $(".lazy").Lazy();

  $("a").on("click", function (e) {
    if (
      $(this).attr("href") == "#" ||
      $(this).attr("href") == "" ||
      $(this).attr("href") == "!#"
    ) {
      e.preventDefault();
    }
  });

  $(".modal-trigger").on("click", function (e) {
    e.preventDefault();
  });

  $(".modal-close").on("click", function (e) {
    e.preventDefault();
  });

  $(".sidenav-close.sidenav-cross").on("click", function (e) {
    e.preventDefault();
  });

  detectSeenElements();

  $(".modal__cross").on("click", function (e) {
    e.preventDefault();
  });

  $("#signUpBtnModal").on("click", function (e) {
    e.preventDefault();
    $("#modalLogin").modal("close");
    setTimeout(function () {
      $("#modalSignUp").modal("open");
    }, 600);
  });

  $("#resetBtnModal").on("click", function (e) {
    e.preventDefault();
    $("#modalLogin").modal("close");
    setTimeout(function () {
      $("#modalReset").modal("open");
    }, 600);
  });

  $(".animated-scroll").on("click", function (e) {
    var linkHref = $(this).attr("href");
    var target =
      linkHref && linkHref.charAt(0) === "#" ? linkHref : "#" + linkHref;
    var $target = $(target);
    if (!$target.length) return;
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $target.offset().top - 120,
      },
      500,
    );
  });

  controlActiveMenu();

  function controlActiveMenu() {
    $(".top-menu-link").each(function () {
      var curHref = $(this).attr("href");
      $(this).removeClass("active");
      if (window.location.pathname.indexOf(curHref) != -1) {
        $(this).addClass("active");
      }
    });
  }

  function controlTopMenu() {
    var scrollHeight = $(window).scrollTop();

    if (scrollHeight > 0) {
      $(".top-menu").addClass("not-top");
    } else {
      $(".top-menu").removeClass("not-top");
    }
    $(window).scroll(function () {
      scrollHeight = $(window).scrollTop();

      if (scrollHeight > 0) {
        $(".top-menu").addClass("not-top");
      } else {
        $(".top-menu").removeClass("not-top");
      }
    });
  }

  function detectSeenElements() {
    var sections = $("section, .animated-block");

    sections.each(function () {
      var top_of_element = $(this).offset().top + $(window).innerHeight() / 2;
      var bottom_of_element = $(this).offset().top + $(this).outerHeight();
      var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
      var top_of_screen = $(window).scrollTop();

      if (
        bottom_of_screen > top_of_element &&
        top_of_screen < bottom_of_element
      ) {
        $(this).addClass("seen");
      }
    });

    $(window).scroll(function () {
      sections.each(function () {
        var top_of_element = $(this).offset().top + $(window).innerHeight() / 2;
        var bottom_of_element = $(this).offset().top + $(this).outerHeight();
        var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        var top_of_screen = $(window).scrollTop();

        if (
          bottom_of_screen > top_of_element &&
          top_of_screen < bottom_of_element
        ) {
          $(this).addClass("seen");
        }
      });
    });
  }

  function addInlineSvg() {
    var mySVGsToInject = document.querySelectorAll("img.image_svg");
    SVGInjector(mySVGsToInject);
  }

  addInlineSvg();
});

if (typeof gdprCookieNotice === "function") {
  gdprCookieNotice({
    locale: "en",
    timeout: 500,
    expiration: 60,
    domain: "aura.partners",
    implicit: false,
    statement: "#",
    performance: [
      "JSESSIONID",
      "_hjIncludedInSample",
      "nQ_visitId",
      "nQ_cookieId",
      "locale",
      "lang",
      "__atuvc",
      "__hstc",
      "__hssrc",
      "__hssc",
      "hsfirstvisit",
      "hubspotutk",
    ],
    analytics: [
      "ga",
      "_ga",
      "_gid",
      "_gat",
      "collect",
      "_ga_user_id",
      "__utmz",
      "__utma",
      "gwcc",
    ],
    marketing: [
      "SSID",
      "IDE",
      "test_cookie",
      "fr",
      "tr",
      "1P_JAR",
      "id",
      "NID",
      "APISID",
      "SAPISID",
      "guest_id",
      "personalization_id",
      "bcookie",
      "bscookie",
      "lidc",
      "MUID",
      "MUIDB",
      "GPS",
    ],
  });
}
